var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBsb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 274,
    height: 88,
    viewBox: "0 0 274 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(-220 -31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M324.257,57.009a.368.368,0,0,1,.369-.368h4.456c2.315,0,4.105,1.549,4.105,3.583a3.69,3.69,0,0,1-2.14,3.078,3.485,3.485,0,0,1,2.529,3.157c0,2.168-1.868,3.737-4.241,3.737h-4.709a.368.368,0,0,1-.369-.368Zm4.591,5.325a1.664,1.664,0,0,0,1.674-1.743,1.586,1.586,0,0,0-1.674-1.646h-2.082v3.389Zm.273,5.577a1.731,1.731,0,0,0,1.75-1.762,1.881,1.881,0,0,0-1.984-1.685h-2.121v3.447Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M345.231,56.448a6.971,6.971,0,1,1-6.985,6.99A6.975,6.975,0,0,1,345.231,56.448Zm0,11.424a4.454,4.454,0,1,0-4.456-4.434A4.474,4.474,0,0,0,345.231,67.872Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M357.412,57.009a.381.381,0,0,1,.369-.368h1.81a.368.368,0,0,1,.369.368V62.14H366.3V57.009a.368.368,0,0,1,.369-.368h1.79a.382.382,0,0,1,.37.368V69.828a.382.382,0,0,1-.37.368h-1.79a.368.368,0,0,1-.369-.368V64.484H359.96v5.344a.368.368,0,0,1-.369.368h-1.81a.381.381,0,0,1-.369-.368Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M374.807,57.009a.381.381,0,0,1,.369-.368h1.848a.368.368,0,0,1,.37.368v7.92a2.833,2.833,0,1,0,5.662.019V57.009a.368.368,0,0,1,.369-.368h1.848a.382.382,0,0,1,.37.368v8.056a5.419,5.419,0,0,1-10.836,0Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M391.208,68.3l.7-1.2a.452.452,0,0,1,.661-.136,6.467,6.467,0,0,0,2.938,1.2,1.623,1.623,0,0,0,1.771-1.491c0-.988-.837-1.666-2.471-2.324-1.829-.736-3.658-1.9-3.658-4.183,0-1.723,1.284-3.717,4.378-3.717a6.867,6.867,0,0,1,3.891,1.3.479.479,0,0,1,.117.639l-.74,1.1a.513.513,0,0,1-.681.232,6.409,6.409,0,0,0-2.7-1.065A1.547,1.547,0,0,0,393.7,60.01c0,.911.72,1.53,2.3,2.169,1.887.756,4.066,1.879,4.066,4.376,0,2-1.731,3.835-4.475,3.835a6.274,6.274,0,0,1-4.28-1.511C391.131,68.705,391.033,68.608,391.208,68.3Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M405.665,57.009a.369.369,0,0,1,.37-.368h1.79a.381.381,0,0,1,.369.368V67.872h4.961a.369.369,0,0,1,.37.368v1.588a.369.369,0,0,1-.37.368h-7.12a.369.369,0,0,1-.37-.368Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M417.9,69.692l6.051-13.032a.348.348,0,0,1,.331-.212h.194a.331.331,0,0,1,.331.212L430.8,69.692a.342.342,0,0,1-.331.5h-1.693a.56.56,0,0,1-.564-.387l-.953-2.092h-5.817l-.953,2.092a.587.587,0,0,1-.565.387h-1.692A.342.342,0,0,1,417.9,69.692Zm8.4-4.124-1.946-4.26H424.3l-1.907,4.26Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M435.785,56.8a.364.364,0,0,1,.37-.348h.486l8.093,8.558h.02v-8a.368.368,0,0,1,.369-.368h1.791a.381.381,0,0,1,.369.368V70.041a.365.365,0,0,1-.369.349h-.467L438.314,61.5H438.3v8.327a.369.369,0,0,1-.37.368h-1.77a.382.382,0,0,1-.37-.368Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M452.674,68.3l.7-1.2a.452.452,0,0,1,.661-.136,6.467,6.467,0,0,0,2.938,1.2,1.623,1.623,0,0,0,1.771-1.491c0-.988-.837-1.666-2.471-2.324-1.829-.736-3.658-1.9-3.658-4.183,0-1.723,1.284-3.717,4.378-3.717a6.867,6.867,0,0,1,3.891,1.3.479.479,0,0,1,.117.639l-.74,1.1a.513.513,0,0,1-.681.232,6.409,6.409,0,0,0-2.7-1.065,1.547,1.547,0,0,0-1.712,1.355c0,.911.72,1.53,2.3,2.169,1.887.756,4.066,1.879,4.066,4.376,0,2-1.731,3.835-4.475,3.835a6.274,6.274,0,0,1-4.28-1.511C452.6,68.705,452.5,68.608,452.674,68.3Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M466.663,57.106a.46.46,0,0,1,.467-.465h1.712a.472.472,0,0,1,.467.465v5.228l4.9-5.5a.463.463,0,0,1,.369-.194h1.946a.411.411,0,0,1,.311.7l-5.077,5.693,5.447,6.487a.425.425,0,0,1-.35.678h-2.121a.424.424,0,0,1-.35-.136l-5.078-6.235v5.906a.472.472,0,0,1-.467.465H467.13a.46.46,0,0,1-.467-.465Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M481.062,69.692l6.051-13.032a.348.348,0,0,1,.33-.212h.2a.329.329,0,0,1,.33.212l5.993,13.032a.342.342,0,0,1-.331.5h-1.693a.559.559,0,0,1-.564-.387l-.953-2.092H484.6l-.953,2.092a.588.588,0,0,1-.565.387h-1.692A.342.342,0,0,1,481.062,69.692Zm8.4-4.124-1.946-4.26h-.058l-1.907,4.26Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M324.257,80.314a.368.368,0,0,1,.369-.368h7.919a.368.368,0,0,1,.369.368V81.9a.368.368,0,0,1-.369.368h-5.759V85.91h4.806a.381.381,0,0,1,.369.368v1.588a.381.381,0,0,1-.369.367h-4.806v4.9a.382.382,0,0,1-.37.368h-1.79a.368.368,0,0,1-.369-.368Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M343.089,79.752a6.971,6.971,0,1,1-6.985,6.99A6.974,6.974,0,0,1,343.089,79.752Zm0,11.425a4.454,4.454,0,1,0-4.456-4.435A4.474,4.474,0,0,0,343.089,91.177Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M354.316,80.314a.369.369,0,0,1,.37-.368h5.564a4.2,4.2,0,0,1,4.241,4.163,4.276,4.276,0,0,1-2.879,3.912l2.665,4.918a.367.367,0,0,1-.331.562H361.9a.332.332,0,0,1-.311-.175l-2.588-5.131h-2.159v4.938a.383.383,0,0,1-.37.368h-1.79a.369.369,0,0,1-.37-.368Zm5.72,5.809a1.977,1.977,0,0,0,1.926-1.975,1.932,1.932,0,0,0-1.926-1.879h-3.171v3.854Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M368.589,91.6l.7-1.2a.451.451,0,0,1,.661-.135,6.469,6.469,0,0,0,2.938,1.2,1.622,1.622,0,0,0,1.771-1.491c0-.987-.837-1.665-2.471-2.323-1.829-.736-3.658-1.9-3.658-4.183,0-1.723,1.284-3.718,4.377-3.718a6.869,6.869,0,0,1,3.892,1.3.478.478,0,0,1,.116.639l-.739,1.1a.512.512,0,0,1-.681.233,6.415,6.415,0,0,0-2.7-1.065,1.547,1.547,0,0,0-1.712,1.355c0,.91.72,1.53,2.3,2.169,1.888.755,4.067,1.878,4.067,4.376,0,2-1.732,3.834-4.475,3.834a6.275,6.275,0,0,1-4.28-1.51C368.512,92.009,368.414,91.913,368.589,91.6Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M380.357,93l6.051-13.032a.35.35,0,0,1,.331-.213h.194a.331.331,0,0,1,.331.213L393.256,93a.342.342,0,0,1-.331.5h-1.692a.558.558,0,0,1-.564-.388l-.954-2.091H383.9l-.953,2.091a.586.586,0,0,1-.564.388h-1.693A.342.342,0,0,1,380.357,93Zm8.4-4.125-1.946-4.26h-.058l-1.907,4.26Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M397.09,80.411a.46.46,0,0,1,.467-.465h1.713a.472.472,0,0,1,.466.465v5.228l4.9-5.5a.467.467,0,0,1,.37-.193h1.945a.411.411,0,0,1,.311.7l-5.077,5.693,5.447,6.487a.425.425,0,0,1-.35.678h-2.121a.424.424,0,0,1-.35-.136l-5.078-6.235v5.906a.472.472,0,0,1-.466.465h-1.713a.46.46,0,0,1-.467-.465Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M411.783,80.314a.368.368,0,0,1,.369-.368h5.564a4.2,4.2,0,0,1,4.242,4.163,4.276,4.276,0,0,1-2.88,3.912l2.666,4.918a.367.367,0,0,1-.331.562H419.37a.333.333,0,0,1-.311-.175l-2.588-5.131h-2.159v4.938a.382.382,0,0,1-.37.368h-1.79a.368.368,0,0,1-.369-.368Zm5.719,5.809a1.977,1.977,0,0,0,1.927-1.975,1.932,1.932,0,0,0-1.927-1.879h-3.171v3.854Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M426.833,80.314a.381.381,0,0,1,.369-.368h1.81a.381.381,0,0,1,.369.368V93.133a.382.382,0,0,1-.369.368H427.2a.382.382,0,0,1-.369-.368Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M434.888,80.1a.365.365,0,0,1,.369-.349h.486l8.094,8.559h.019v-8a.369.369,0,0,1,.37-.368h1.79a.382.382,0,0,1,.37.368V93.346a.365.365,0,0,1-.37.348h-.467l-8.132-8.888h-.02v8.327a.368.368,0,0,1-.369.368h-1.771a.382.382,0,0,1-.369-.368Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M458.064,79.752a7.371,7.371,0,0,1,4.747,1.8.373.373,0,0,1,.02.542l-1.206,1.259a.333.333,0,0,1-.506,0,4.429,4.429,0,1,0-2.918,7.8,6.129,6.129,0,0,0,2.315-.484V89.028h-1.557a.353.353,0,0,1-.369-.349v-1.53a.356.356,0,0,1,.369-.368H462.7a.365.365,0,0,1,.35.368v4.957a.374.374,0,0,1-.155.31,9.864,9.864,0,0,1-4.826,1.259,6.962,6.962,0,1,1,0-13.923Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M466.527,93l6.05-13.032a.351.351,0,0,1,.331-.213h.2a.33.33,0,0,1,.33.213L479.426,93a.342.342,0,0,1-.331.5H477.4a.559.559,0,0,1-.564-.388l-.953-2.091h-5.817l-.954,2.091a.586.586,0,0,1-.564.388h-1.692A.342.342,0,0,1,466.527,93Zm8.4-4.125-1.946-4.26h-.058l-1.907,4.26Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M483.351,80.314a.369.369,0,0,1,.37-.368h5.564a4.2,4.2,0,0,1,4.241,4.163,4.276,4.276,0,0,1-2.879,3.912l2.665,4.918a.366.366,0,0,1-.33.562h-2.043a.332.332,0,0,1-.311-.175l-2.588-5.131h-2.159v4.938a.382.382,0,0,1-.37.368h-1.79a.369.369,0,0,1-.37-.368Zm5.72,5.809A1.977,1.977,0,0,0,491,84.148a1.932,1.932,0,0,0-1.926-1.879H485.9v3.854Z",
    fill: "#375e7f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M383.552,77.624a.382.382,0,0,1-.37-.369v-1.41a.382.382,0,0,1,.37-.368H390.1a.383.383,0,0,1,.369.368v1.41a.383.383,0,0,1-.369.369Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M339.827,77.624a.382.382,0,0,1-.37-.369v-1.41a.382.382,0,0,1,.37-.368h6.543a.383.383,0,0,1,.369.368v1.41a.383.383,0,0,1-.369.369Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M421.105,54.337a.383.383,0,0,1-.37-.369V52.557a.381.381,0,0,1,.37-.367h6.542a.382.382,0,0,1,.37.367v1.411a.383.383,0,0,1-.37.369Z",
    fill: "#375e7f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M241.8,52.376a.44.44,0,0,0-.442.439v32.3a.441.441,0,0,0,.442.44h6.306c4.229-.011,6.374-2.242,6.374-6.631V73.752c0-2-1.114-3.6-3.312-4.728l-.112-.058.112-.058c2.2-1.132,3.312-2.722,3.312-4.727V59.023c0-4.4-2.03-6.636-6.034-6.647Zm6.137,29.473h-2.784V70.829h2.154a5.043,5.043,0,0,1,1.655.191,2.659,2.659,0,0,1,1.724,2.732v5.175C250.689,80.866,249.764,81.849,247.94,81.849ZM247.31,67.1h-2.154V56.084h2.784c1.824,0,2.749.989,2.749,2.939v5.158a2.707,2.707,0,0,1-1.723,2.748A5.614,5.614,0,0,1,247.31,67.1Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M258.14,72.86a.441.441,0,0,0-.442.44v6.29c0,4.389,2.213,6.62,6.577,6.631,4.342,0,6.544-2.231,6.544-6.631V72.834c0-1.908-2.965-6.57-5.58-10.929-2.011-3.35-3.748-5.874-3.748-7V49.317c0-1.928.926-2.906,2.75-2.906h.034c1.825.012,2.75.99,2.75,2.906v6.308a.441.441,0,0,0,.441.439h2.911a.441.441,0,0,0,.442-.439V49.317c0-4.389-2.207-6.614-6.561-6.614s-6.56,2.225-6.56,6.614v6c0,2.135,2.92,6.28,5.5,10.635,2.055,3.475,3.831,6.142,3.831,7.3V79.59c0,1.928-.926,2.906-2.75,2.906-1.847,0-2.784-.978-2.784-2.906V73.3a.441.441,0,0,0-.441-.44Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M274.426,52.376a.44.44,0,0,0-.442.439v32.3a.441.441,0,0,0,.442.44h6.645c4-.011,6.034-2.248,6.034-6.648V73.752c0-2-1.114-3.594-3.312-4.727l-.112-.058.112-.057c2.2-1.133,3.312-2.724,3.312-4.729V59.007c0-4.389-2.144-6.62-6.374-6.631Zm6.135,29.474h-2.783V70.83h2.155a5.607,5.607,0,0,1,1.652.173,2.708,2.708,0,0,1,1.726,2.749V78.91C283.311,80.861,282.386,81.85,280.561,81.85ZM279.933,67.1h-2.155V56.085h2.783c1.825,0,2.75.983,2.75,2.922v5.174a2.659,2.659,0,0,1-1.723,2.732A5.044,5.044,0,0,1,279.933,67.1Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M264.208,119a44.1,44.1,0,1,1,31.259-12.887A44.026,44.026,0,0,1,264.208,119Zm0-84.753A40.753,40.753,0,1,0,305.152,75,40.9,40.9,0,0,0,264.208,34.247Z",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    d: "M.445,0H45.31a.445.445,0,0,1,.445.445V2.412a.445.445,0,0,1-.445.445H.447A.447.447,0,0,1,0,2.41V.445A.445.445,0,0,1,.445,0Z",
    transform: "translate(241.361 89.825)",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    d: "M.445,0H31.029a.447.447,0,0,1,.447.447V2.412a.445.445,0,0,1-.445.445H.445A.445.445,0,0,1,0,2.412V.445A.445.445,0,0,1,.445,0Z",
    transform: "translate(248.501 96.36)",
    fill: "#375e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    d: "M.445,0h16.3A.447.447,0,0,1,17.2.447V2.412a.445.445,0,0,1-.445.445H.447A.447.447,0,0,1,0,2.41V.445A.445.445,0,0,1,.445,0Z",
    transform: "translate(255.64 102.896)",
    fill: "#375e7f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsb);
export default __webpack_public_path__ + "static/media/bsb.f0e7df01a0b8c29ae5ced9aa07b73f64.svg";
export { ForwardRef as ReactComponent };